import React from 'react';

import Meeter from './Meeter'
import MeetingSettingsForm from './MeetingSettingsForm';

const Meeting = () => {
  document.title = "WebRTC Meeting Test for Wowza Streaming Engine";

  return (
    <div className="row justify-content-center">
      <div className="col-md-8 col-sm-12">
        <div id="peer-video-container">
          <Meeter />
        </div>
      </div>
      <MeetingSettingsForm />
    </div>
  );
}

export default Meeting;
